import React from 'react';
import { LinkOutlined } from '@ant-design/icons';
import { AgentFinder } from '../AgentFinder';
import {
  HubWelcome as HubWelcome__Root,
  HubWelcome__Logo,
  HubWelcome__Title,
  HubWelcome__Message,
  HubWelcome__Disclaimer,
  HubWelcome__DisclaimerTitle,
  HubWelcome__DisclaimerText,
  HubWelcome__Divider,
  HubWelcome__Subtext,
  HubWelcome__Link,
} from './HubWelcome.styles';

export const HubWelcome: React.FC = () => {
  return (
    <HubWelcome__Root>
      <HubWelcome__Logo src="/images/Grundfos_Logo-Symbol_Blue_SCREEN.svg" alt="Grundfos" />

      <HubWelcome__Title>
        Welcome to the AI Agent Hub
      </HubWelcome__Title>

      <HubWelcome__Message>
        This is the central hub for all chatbot solutions developed by the
        Intelligent Automation team. Select an agent from the list to start
        a conversation.
      </HubWelcome__Message>

      <HubWelcome__Disclaimer>
        <HubWelcome__DisclaimerTitle>
          AI-Generated Content Disclaimer
        </HubWelcome__DisclaimerTitle>
        <HubWelcome__DisclaimerText>
          Responses from these agents are AI-generated and may include
          inaccurate, incomplete, or outdated information. Please verify
          important details with trusted sources and do not treat agent
          responses as a single source of truth.
        </HubWelcome__DisclaimerText>
      </HubWelcome__Disclaimer>

      <HubWelcome__Divider />

      <AgentFinder />

      <HubWelcome__Divider />

      <HubWelcome__Subtext>
        Want to stay aware of the latest information from our department?
        Join us on Viva Engage to get updates, share feedback, and connect
        with the team.
      </HubWelcome__Subtext>

      <HubWelcome__Link
        href="https://engage.cloud.microsoft/main/org/grundfos.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIxMjE3Njk2NyJ9"
        target="_blank"
        rel="noopener noreferrer"
      >
        <LinkOutlined />
        Join us on Viva Engage
      </HubWelcome__Link>
    </HubWelcome__Root>
  );
};
